import { Post } from '@/core/services/interfaces/PostInterfaces';

/**
 * SAC types that represent interactions (comments, mentions, inbox messages)
 * that cannot be refreshed (static) because the API doesn't support it.
 */
const STATIC_INTERACTION_SAC_TYPES = new Set([
  'mention',
  'inbox',
  'review',
  'visitorpost',
  'postcomment',
  'mentioncomment',
  'externalcomment',
  'reviewcomment',
  'visitorcomment',
]);

/**
 * Returns `true` when the post is an interaction (comment, mention, inbox, etc.)
 * that cannot be refreshed (static) because the API doesn't support it.
 * and `false` when it is an interaction that can be refreshed.
 */
export function isStaticInteraction(post: Post): boolean {
  const sacType = (post.sac_type ?? '').trim().toLowerCase();
  if (STATIC_INTERACTION_SAC_TYPES.has(sacType)) return true;

  const channelLabel = (post.channel ?? '')
    .trim()
    .normalize('NFD')
    .replaceAll(/[\u0300-\u036f]/g, '')
    .toLowerCase();
  if (channelLabel.includes('comentario')) {
    return true;
  }

  return false;
}
